<template>
  <div><div class="home">login</div>
  <div class="py-5">{{ message }}</div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      message: 'test'
    }
  }
}
</script>
